/**
 * Client capability advertisement. The backend RequestGate rejects gated requests from clients
 * that don't advertise the expected capability with a 409 `client_capabilities_required`. Matching
 * is exact (`calculator:2` does not satisfy `calculator:1`) — bump in lockstep with the backend
 * gate registry.
 */

export const CLIENT_CAPABILITIES_HEADER = 'X-Kickfin-Client-Capabilities';

export const CALCULATOR_CAPABILITY = 'calculator:1';

export const CLIENT_CAPABILITIES_REQUIRED_CODE = 'client_capabilities_required';

// Stable id so simultaneous gated failures collapse to a single refresh prompt.
export const CLIENT_CAPABILITIES_TOAST_ID = 'client-capabilities-required';

export const calculatorCapabilityHeaders = (): Record<string, string> => ({
  [CLIENT_CAPABILITIES_HEADER]: CALCULATOR_CAPABILITY,
});

interface IApiErrorEntry {
  code?: string;
  msg?: string;
}

const isClientCapabilitiesErrorEntry = (error: IApiErrorEntry | undefined | null): boolean => error?.code === CLIENT_CAPABILITIES_REQUIRED_CODE;

export const findClientCapabilitiesError = (errors: unknown): IApiErrorEntry | undefined => (Array.isArray(errors) ? (errors as IApiErrorEntry[]).find(isClientCapabilitiesErrorEntry) : undefined);

// Accepts a bare errors[] array, an { errors } envelope, or an ApiError ({ body: { errors } }).
export const hasClientCapabilitiesError = (candidate: any): boolean => {
  const errors = Array.isArray(candidate) ? candidate : (candidate?.errors ?? candidate?.body?.errors);
  return !!findClientCapabilitiesError(errors);
};
